import { Grid, Typography } from '@mui/material';
import useCommonStyles from '../../../../../../commonStyles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import HLSPlayer from '../../../../../../Components/HlsPlayer';

/**
 * Modal Component for viewing the contents of a mapped playlist.
 */
const ViewPlaylistModal = ({ playlistName, videosList, lastModified }) => {
	const commonStyleClasses = useCommonStyles();
	return (
		<Grid
			container
			spacing={2}
			className={commonStyleClasses.modalContentStyle}
			style={{ overflowY: 'scroll', maxHeight: '50rem', padding: '2rem' }}
		>
			<Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography variant="h4" color="primary" textAlign="center" fontWeight="600">
					{playlistName}
				</Typography>
				<Typography>{lastModified ? `Last Modified : ${lastModified}` : ''}</Typography>
			</Grid>

			{(videosList?.length > 0 &&
				videosList?.map((videoObj) => {
					return (
						<Grid item xs={6} key={playlistName}>
							<Card style={{ width: '100%' }}>
								<CardContent>
									<Grid container>
										<Grid item xs={6}>
											<Typography variant="h6" fontWeight={600}>
												{videoObj.videoName}
											</Typography>
										</Grid>
										{videoObj?.transcodedUrl ? (
											<HLSPlayer
												cdn77PathUrl={videoObj?.transcodedUrl}
												azurePublicUrl={videoObj?.azureUrl}
											/>
										) : (
											// Added CardMedia as fallback method in case cdn77PathUrl doesn't exist
											<CardMedia
												component="video"
												sx={{ height: '15rem', marginTop: '2rem' }}
												controls
												src={videoObj.azureUrl}
											/>
										)}
									</Grid>
								</CardContent>
							</Card>
						</Grid>
					);
				})) || (
				<Grid item xs={12}>
					<Typography variant="body1" textAlign="center" style={{ margin: '5rem 0' }}>
						Videos will be displayed Here once Mapping is Processed.
					</Typography>
				</Grid>
			)}
		</Grid>
	);
};

export default ViewPlaylistModal;
